import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const showWhite = !isHome || scrolled;

  useEffect(() => {
    if (!isHome) return;
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  const navLinks = [
    { label: 'Über uns', to: '/ueber-uns' },
    { label: 'Leistungen', to: '/leistungen' },
    { label: 'Kontakt', to: '/kontakt' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        showWhite
          ? 'bg-background-50 border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex flex-col leading-none"
          >
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight transition-colors duration-300 ${
              showWhite ? 'text-primary-600' : 'text-white'
            }`}>
              Rahmede
            </span>
            <span className={`text-[10px] md:text-xs tracking-[0.2em] uppercase transition-colors duration-300 ${
              showWhite ? 'text-foreground-500' : 'text-white/70'
            }`}>
              Druckerei
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                  showWhite
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/kontakt"
              className={`px-5 py-2.5 rounded-md text-sm font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer ${
                showWhite
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm'
              }`}
            >
              Angebot anfordern
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-md transition-colors ${
              showWhite ? 'text-foreground-800' : 'text-white'
            }`}
            aria-label="Menü öffnen"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-foreground-700 hover:text-primary-600 py-2 transition-colors"
            >
              Home
            </Link>
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className="text-sm font-medium text-foreground-700 hover:text-primary-600 py-2 transition-colors"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/kontakt"
              onClick={() => setMobileOpen(false)}
              className="bg-primary-500 text-white text-sm font-semibold px-5 py-2.5 rounded-md text-center whitespace-nowrap cursor-pointer mt-2 hover:bg-primary-600 transition-colors"
            >
              Angebot anfordern
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}